import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { IJsonQueryPolygon, TCoordinate } from 'shared/common/packages/api-models/common/json_query';
import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';
import { selectIsDrawingMode } from 'shared/map-search/selectors/drawing';
import { selectInvertedPolygons } from 'shared/map-search/selectors/results';

import { Polygons } from './Polygons';
import { useMapContext } from '../../context';

export const PolygonsContainer = () => {
  const { ymaps, map } = useMapContext();
  const { microfrontendsAPI } = useApplicationContext();
  const filtersMicrofrontendApi = microfrontendsAPI?.filters;
  const isDrawingMode = useSelector(selectIsDrawingMode);
  const polygons = useSelector(selectInvertedPolygons);

  const handleAddPolygon = useCallback(
    (polygon: IJsonQueryPolygon) => {
      const coordinates: TCoordinate[] = polygon.coordinates.map(([a, b]) => [
        parseFloat(Number(b).toFixed(7)).toString(),
        parseFloat(Number(a).toFixed(7)).toString(),
      ]);

      coordinates.push(coordinates[0]);

      /**
       * @description
       * Добавление фильтра полигона триггерит применение фильтров и вызов экшена makeSearch.
       * Тем самым происходит обновление кластеров на карте.
       */
      filtersMicrofrontendApi?.addPolygonFilter({ ...polygon, coordinates });
    },
    [filtersMicrofrontendApi],
  );

  return (
    <Polygons polygons={polygons} addPolygon={handleAddPolygon} isDrawingMode={isDrawingMode} ymaps={ymaps} map={map} />
  );
};
